import { NL_STRING } from "./index";

//const apiPath = 'http://10.56.11.3:80';
//const apiPath = 'http://localhost:80';
//const apiPath = 'http://2020.literatuurengeneeskunde.nl';
const apiPath = 'http://databases.literatuurengeneeskunde.nl';
//const apiPath = 'http://localhost:80';

/**
 * Get the full string used by fetch to connect to the api
 * @param {String} locale The set locale, 'en' | 'nl'
 * @param {String} endPoint The endpoint where the component gets its data from
 * @param {Array} params Optional array of extra params, for instance id
 */
export const getApiPath = (locale = NL_STRING, endPoint = "", params = []) => {
  // For when a dev forgets
  if (!Array.isArray(params)) {
    params = [params];
  }
  return [apiPath, "api", locale, endPoint, ...params].join("/");
};

export default apiPath;
